<!--Vista para editar información que se muestra en el micrositio del evento-->
<template>
  <v-container fluid>
    <div>
      <v-card color="px-0 px-md-5 py-7 rounded-xl elevation-0">
        <v-row>
          <v-col cols="12" md="8" class="py-0">
            <h2 class="font-weight-bold">
              Vamos a construir tu micrositio de evento
            </h2>
          </v-col>
          <v-col cols="12" md="4" class="py-0 d-flex flex-row justify-end">
            <!--<span class="mt-3 mr-3">Publicar evento</span>
            <v-switch
              class="mt-2"
              color="accent"
              hide-details
            ></v-switch>-->
            <!--
              $_publishEvent()
            -->
            <v-tooltip v-if="!eventData.published" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="openNotificationDialog" color="secondary" large rounded v-bind="attrs" v-on="on"
                  :disabled="!user.permissions.Event || !user.permissions.Event.update
              ">
                  <span class="font-weight-bold">Publicar evento</span>
                </v-btn>
              </template>
              <span>Da clic para publicar tu evento y permitir que tus asistentes
                se registren</span>
            </v-tooltip>
            <v-tooltip v-else top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="$_hideEvent" color="grey lighten-3" large rounded v-bind="attrs" v-on="on" :disabled="!user.permissions.Event || !user.permissions.Event.update
              ">
                  <span class="font-weight-bold">Ocultar evento</span>
                </v-btn>
              </template>

              <span>Da clic para bloquear el registro a tu evento</span>
            </v-tooltip>

            <v-dialog v-model="confirmationDialog" max-width="600">
              <v-card class="px-4 py-4">
                <v-card-title class="title font-weight-bold mb-1" style="word-break: break-word;">
                  ¿Desea publicar este evento?
                </v-card-title>
                <v-card-text>
                  <div class="mb-4">
                    <p class="font-weight-bold mb-2">Este evento estará visible para:</p>
                    <div
                      v-if="eventData.exclusiveForMembers === true && audienceSummary.length"
                      class="d-flex flex-wrap"
                    >
                      <v-chip
                        v-for="item in audienceSummary"
                        :key="`publish-${item.key}`"
                        class="mr-2 mb-2"
                        :color="colors.primaryVariant"
                        text-color="white"
                        small
                      >
                        <span class="font-weight-bold mr-1">{{ item.categoryLabel }}:</span>
                        {{ item.names.join(" - ") }}
                      </v-chip>
                    </div>
                    <p
                      v-else-if="eventData.exclusiveForMembers === true"
                      class="text-caption grey--text text--darken-1 mb-0"
                    >
                      Solo miembros de la organización que cumplan las reglas de audiencia.
                    </p>
                    <p v-else class="text-caption grey--text text--darken-1 mb-0">
                      Público general y miembros de la organización.
                    </p>
                  </div>
                  <AudienceDialog
                    ref="audience_configs_modal"
                    :event="eventData._id"
                    :eventExclusive="eventData.exclusiveForMembers === true"
                    :savedRules="audienceDraftRules"
                    :notificationsOnly="true"
                    :hideBranches="!hasChapters"
                  />
                  <v-checkbox
                    hide-details
                    class="shrink"
                    label="Ocultar el evento en micrositio público"
                    v-model="eventData.micrositeConfiguration.hideOnPublicMicrosite"
                    @change="_updateEvent()"
                  >
                  </v-checkbox>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                  <v-btn color="grey lighten-2" class="rounded-pill font-weight-bold px-4" elevation="0" @click="confirmationDialog = false">
                    Cancelar
                  </v-btn>
                  <v-btn color="accent" class="rounded-pill font-weight-bold px-4" elevation="0" @click="confirmPublish">
                    Publicar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" class="pb-0">
                <p class="title font-weight-bold mb-1">
                  Banner y diseño del evento
                </p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" class="py-0">
                <p>
                  Carga un banner de 1500x500 píxeles
                  <v-tooltip top max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                    </template>
                    <span>Esta imagen se mostrará en la parte superior del
                      micrositio. Para tener una visualización adecuada se
                      recomienda que la imagen sea de 1500x500 pixeles.</span>
                  </v-tooltip>
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pt-0">
                <v-img v-if="eventData.banner && eventData.banner != ''" class="align-content-center rounded-xl" width="auto"
                  height="350" :src="eventData.banner">
                  <div class="d-flex justify-center" style="height: 100%; align-items: center">
                    <v-btn color="accent" fab large @click="bannerDialog = true" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              ">
                      <i class="fas fa-plus fa-2x black--text"></i>
                    </v-btn>
                  </div>
                </v-img>
                <v-img v-else class="align-content-center rounded-xl" width="auto" height="350"
                  src="@/assets/images/dashboard/bannerPlaceholder.png">
                  <div class="d-flex justify-center" style="height: 100%; align-items: center">
                    <v-btn color="accent" fab large @click="bannerDialog = true" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              ">
                      <i class="fas fa-plus fa-2x black--text"></i>
                    </v-btn>
                  </div>
                </v-img>
              </v-col>
              <!--<v-col cols="12" sm="10" :class="$vuetify.breakpoint.xsOnly?'pb-0':''">
                <div :class="$vuetify.breakpoint.smAndUp?'d-flex flex-row':''">
                  <span class="subtitle-2 font-weight-light align-self-center mr-2 mb-7">https://wechamber.mx/eventos/</span>
                  <v-text-field
                    v-model="eventData.micrositeConfiguration.link"
                    label="Capa de link"
                    filled
                    rounded
                    @blur="_updateEvent()"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" sm="2" :class="$vuetify.breakpoint.xsOnly?'d-flex justify-center pt-0':''">
                <v-btn color="accent" fab>
                  <i class="fas fa-link fa-lg black--text"></i>
                </v-btn>
              </v-col>-->
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" class="py-0">
                <p>
                  Carga un flyer de 800xN píxeles
                  <v-tooltip top max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                    </template>
                    <span>Esta imagen se mostrará en el cuerpo del micrositio.
                      Normalmente se usa para mostrar información del evento de
                      una forma más gráfica. Para tener una visualización
                      adecuada se recomienda que la imagen sea de 800 pixeles de
                      ancho y de alto puede ser cualquier medida.</span>
                  </v-tooltip>
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="8" class="pt-0" :key="imageComponentKey">
                <v-img v-if="eventData.flyer && eventData.flyer != ''" class="align-content-center rounded-xl" width="auto"
                  height="350" :src="eventData.flyer.split(',')[0]">
                  <div class="d-flex justify-center" style="height: 100%; align-items: center">
                    <v-btn color="accent" fab large @click="flyerDialog = true" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              ">
                      <i class="fas fa-plus fa-2x black--text"></i>
                    </v-btn>
                  </div>
                </v-img>
                <v-img v-else class="align-content-center rounded-xl" width="auto" height="350"
                  src="@/assets/images/dashboard/flyerPlaceholder.png">
                  <div class="d-flex justify-center" style="height: 100%; align-items: center">
                    <v-btn color="accent" fab large @click="flyerDialog = true" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              ">
                      <i class="fas fa-plus fa-2x black--text"></i>
                    </v-btn>
                  </div>
                </v-img>
              </v-col>
              <!--
              <v-col cols="12" sm="8">
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      v-model="eventData.name"
                      label="Dale un nombre a tu evento"
                      filled
                      rounded
                      @blur="_updateEvent()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center pt-0">
                    <v-btn class="black--text font-weight-bold" color="accent" x-large @click="descriptionDialog = true">
                      Descripción de evento
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>-->
              <v-col cols="12" sm="4">
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-text-field v-model="eventData.name" label="Dale un nombre a tu evento" filled rounded :readonly="!user.permissions.Event ||
              !user.permissions.Event.update
              " @blur="_updateEvent()"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field v-model="eventData.emailContact" label="Correo electrónico de contacto" filled rounded
                      :readonly="!user.permissions.Event ||
              !user.permissions.Event.update
              " @blur="_updateEvent()"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field v-model="eventData.youtubeVideo" label="Link de video promocional" filled rounded
                      :readonly="!user.permissions.Event ||
              !user.permissions.Event.update
              " @blur="_updateEvent()"></v-text-field>
                  </v-col>
                </v-row>
                <!--
                <v-row>
                  <v-col>
                    <v-card class="align-content-center" min-height="150" max-height="200" :color="eventData.micrositeConfiguration.primaryColor">
                      <div class="d-flex align-content-space-between flex-wrap" style="min-height: 150px; min-height: 150px; align-items: center;" min-height="150" max-height="200">
                        <div class="ma-4" style="width: 100%">
                          <p class="title font-weight-bold ma-0" :style="`color: ${eventData.micrositeConfiguration.secondaryColor}`">
                            Texto
                          </p>
                        </div>
                        <div class="ma-4 d-flex justify-end" style="width: 100%">
                          <v-btn :color="eventData.micrositeConfiguration.buttonColor" rounded :dark="eventData.micrositeConfiguration.textButtonColor=='white'"><span class="font-weight-bold">Botón</span></v-btn>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>-->
              </v-col>
            </v-row>
          </v-col>
          <!--INICIO sección Audiencia (segmentación siempre visible) -->
          <v-col cols="12" class="pb-0">
            <p class="title font-weight-bold">Audiencia</p>
          </v-col>
          <v-col cols="12" class="py-0">
            <p class="mb-3">
              Por defecto, este evento estará visible para miembros y no miembros.
              <v-tooltip top max-width="350px">
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                </template>
                <span>Esta segmentación se aplica a tu evento publicado y puede
                  editarse en cualquier momento.</span>
              </v-tooltip>
            </p>
            <v-switch
              class="mt-0"
              color="primary"
              :input-value="eventData.exclusiveForMembers === true"
              :disabled="!user.permissions.Event || !user.permissions.Event.update"
              @change="setExclusiveForMembers"
            >
              <template v-slot:label>
                <span>Evento exclusivo para miembros de mi organización</span>
              </template>
            </v-switch>
            <p class="text-caption grey--text text--darken-1 mt-n2">
              Al activar el switch, este evento no estaría visible para público general, solo dentro de los perfiles de miembros
            </p>
            <div v-if="audienceSummary.length" class="d-flex flex-wrap mb-3">
              <v-chip
                v-for="item in audienceSummary"
                :key="item.key"
                class="mr-2 mb-2"
                :color="colors.primaryVariant"
                text-color="white"
                small
              >
                <span class="font-weight-bold mr-1">{{ item.categoryLabel }}:</span>
                {{ item.names.join(" - ") }}
              </v-chip>
            </div>
            <div>
              <AudienceDialog
                ref="audience_configs_persistent"
                :event="eventData._id"
                :eventExclusive="eventData.exclusiveForMembers === true"
                :editMode="true"
                :savedRules="audienceDraftRules"
                :disableNotifications="true"
                :hideBranches="!hasChapters"
                @change="onAudienceRulesChange"
              />
              <v-btn
                class="mt-2"
                color="secondary"
                rounded
                :disabled="!user.permissions.Event || !user.permissions.Event.update || !hasAudienceChanges"
                @click="saveAudienceFromCard"
              >
                <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
                <span class="font-weight-bold text-capitalize">Guardar audiencia</span>
              </v-btn>
              <span
                v-if="user.permissions.Event && user.permissions.Event.update && !hasAudienceChanges"
                class="text-caption grey--text text--darken-1 ml-3"
              >
                Sin cambios pendientes
              </span>
            </div>
          </v-col>
          <v-col cols="12" class="pt-8 pb-4">
            <v-divider class="primary" />
          </v-col>
          <!--FIN sección Audiencia -->
          <v-col cols="12" class="pb-0">
            <p class="title font-weight-bold">Configuración de colores</p>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-row>
              <v-col cols="12" sm="3" class="py-0">
                <v-text-field class="mt-0" label="Color primario" filled rounded readonly
                  @click="primaryColorDialog = true" :disabled="!user.permissions.Event || !user.permissions.Event.update
              ">
                  <template v-slot:append>
                    <v-icon :color="eventData.micrositeConfiguration.primaryColor" large @click="primaryColorDialog = true"
                      :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              ">fas fa-square</v-icon>
                  </template>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="350px">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                      </template>
                      <span>Será el color más visible dentro de tu micrisitio,
                        puedes elegir tu color institucional o el de tu
                        preferencia.</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="py-0">
                <v-text-field label="Color secundario" filled rounded readonly @click="secondaryColorDialog = true"
                  :disabled="!user.permissions.Event || !user.permissions.Event.update
              ">
                  <template v-slot:append>
                    <v-icon :color="eventData.micrositeConfiguration.secondaryColor" large
                      @click="secondaryColorDialog = true" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              ">fas fa-square</v-icon>
                  </template>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="350px">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                      </template>
                      <span>Aquí puedes elegir el color del botón de adquirir
                        acceso y el color de las amenidades.</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="py-0">
                <v-text-field label="Color botón" filled rounded readonly @click="buttonColorDialog = true" :disabled="!user.permissions.Event || !user.permissions.Event.update
              ">
                  <template v-slot:append>
                    <v-icon :color="eventData.micrositeConfiguration.buttonColor" large @click="buttonColorDialog = true"
                      :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              ">fas fa-square</v-icon>
                  </template>
                  <!--<template v-slot:append-outer>
                    <v-tooltip top max-width="350px">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="primary"
                          dark
                          v-on="on"
                          >mdi-help-circle</v-icon
                        >
                      </template>
                      <span
                        >Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium distinctio quia neque, voluptatibus, pariatur eum velit perspiciatis laboriosam veritatis, exercitationem reprehenderi.</span
                      >
                    </v-tooltip>
                  </template>-->
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pt-0">
                <v-switch v-model="eventData.micrositeConfiguration.textButtonColor" class="mt-0" color="black"
                  false-value="white" true-value="black" :label="`Texto botón ${eventData.micrositeConfiguration.textButtonColor == 'black'
              ? '(Negro)'
              : '(Blanco)'
              }`" @change="_updateEvent()" :disabled="!user.permissions.Event || !user.permissions.Event.update
              ">
                  <template v-slot:label>
                    {{
              `Texto botón ${eventData.micrositeConfiguration.textButtonColor == "black"
                ? "(Negro)"
                : "(Blanco)"
              }`
            }}
                    <!--<v-tooltip top max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        color="primary"
                        class="ml-2"
                        dark
                        v-on="on"
                        >mdi-help-circle</v-icon
                      >
                    </template>
        <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium distinctio quia neque, voluptatibus,
          pariatur eum velit perspiciatis laboriosam veritatis, exercitationem reprehenderi.</span>
        </v-tooltip>-->
                  </template>
                </v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row class="py-5 mx-1" v-bind:style="`background-color: ${eventData.micrositeConfiguration &&
                eventData.micrositeConfiguration.primaryColor
                ? eventData.micrositeConfiguration.primaryColor
                : '#f0f0f0'
              }; border-radius: 20px`">
              <v-col cols="12" md="8" lg="9" class="pl-12">
                <p class="mb-1 font-weight-medium subtitle-1"
                  :style="`color: ${eventData.micrositeConfiguration.secondaryColor}`">
                  {{ dateEvent() }}
                </p>
                <p class="mb-1 font-weight-black display-1"
                  :style="`color: ${eventData.micrositeConfiguration.secondaryColor}`">
                  {{ eventData.name }}
                </p>
                <!--<p
                  class="mb-1 font-weight-medium subtitle-1"
                  :style="`color: ${eventData.micrositeConfiguration.secondaryColor}`"
                >
                  {{eventData.type}} / {{eventData.category}}
                </p>-->
                <p class="mb-1 font-weight-medium subtitle-1"
                  :style="`color: ${eventData.micrositeConfiguration.secondaryColor}`">
                  <v-icon :color="eventData.micrositeConfiguration.secondaryColor">
                    {{
              eventData.eventModality == "PRESENTIAL"
                ? "mdi-google-maps"
                : eventData.eventModality == "VIRTUAL"
                  ? "mdi-earth"
                  : "mdi-merge"
            }}
                  </v-icon>
                  {{ eventModalities[eventData.eventModality] }}
                </p>
              </v-col>
              <v-col cols="12" md="4" lg="3" class="d-flex align-center">
                <v-row class="d-flex justify-end">
                  <!--<v-col cols="12" class="pa-0 d-flex justify-center">
                    <p
                      class="font-weight-bold subtitle-1"
                      :style="`color: ${eventData.micrositeConfiguration.secondaryColor}`"
                    >
                      ¡Quedan pocos lugares!
                    </p>
                  </v-col>-->
                  <v-col cols="12" class="pa-0 d-flex justify-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="font-weight-bold" :color="eventData.micrositeConfiguration.buttonColor" rounded :dark="eventData.micrositeConfiguration.textButtonColor ==
              'white'
              " v-bind="attrs" v-on="on">Adquirir acceso
                        </v-btn>
                      </template>
                      <span>Botón ilustrativo, no tiene funcionalidad</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pb-0">
            <p class="title font-weight-bold mb-0">Descripción del evento</p>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="8">
                <v-row>
                  <v-col cols="12">
                    <tiptap-vuetify v-model="eventData.description" :extensions="extensions"
                      :max-height="$vuetify.breakpoint.smAndUp ? '450' : '250'" :toolbar-attributes="{
              color: 'primary',
              rounded: 't-lg',
              dark: true,
            }" :card-props="{
              elevation: '0',
              rounded: 'lg',
              color: '#f0f0f0',
            }" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              " />
                  </v-col>
                  <v-col cols="12">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="font-weight-bold black--text" color="secondary" rounded v-bind="attrs" v-on="on"
                          @click="_updateEvent()" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              ">Guardar descripción</v-btn>
                      </template>
                      <span>Guardar cambios de descripción del evento</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-select v-model="eventData.eventModality" :items="modalityCategories" label="Modalidad" filled rounded
                      @change="_updateEvent()" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              ">
                      <template slot="selection" slot-scope="data">
                        <span>{{ data.item.item }}</span>
                      </template>
                      <template slot="item" slot-scope="data">
                        <span>{{ data.item.item }}</span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col v-if="eventData.eventModality == 'PRESENTIAL' ||
              eventData.eventModality == 'HYBRID'
              " cols="12">
                    <div
                      class="v-input theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed v-text-field--rounded">
                      <div class="v-input__control d-flex">
                        <div class="v-input__slot">
                          <div class="v-input__prepend-inner">
                            <div class="v-input__icon v-input__icon--prepend-inner">
                              <i aria-hidden="true" class="v-icon notranslate fas fa-map-marker-alt theme--light"></i>
                            </div>
                          </div>
                          <div class="v-text-field__slot">
                            <label for="input-274" class="v-label theme--light"
                              style="left: 0px; right: auto; position: absolute"></label>
                            <gmap-autocomplete placeholder="Ubicación del recinto *" required style="margin-top: 15px"
                              @place_changed="saveAddress" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              " :value="place"></gmap-autocomplete>
                          </div>
                        </div>
                      </div>
                      <v-tooltip top max-width="350px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on" class="ml-2 mt-4">mdi-help-circle</v-icon>
                        </template>
                        <span>Para llenar este campo correctamente es necesario
                          seleccionar alguna de las opciones que se sugieren al
                          momento de estar escribiendo la ubicación.</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col v-if="eventData.virtualEventConfiguration &&
              (eventData.eventModality == 'VIRTUAL' ||
                eventData.eventModality == 'HYBRID')
              " cols="12" class="py-0 py-sm-2">
                    <v-text-field v-model="eventData.virtualEventConfiguration.url" label="Url de Webinar" filled rounded
                      :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              " @blur="_updateEvent()"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pb-0">
            <p class="title font-weight-bold">Redes sociales</p>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-row v-if="eventData.socialMedia">
              <v-col cols="12" sm="3" class="py-0">
                <v-text-field v-model="eventData.socialMedia.facebook" class="mt-0" label="Facebook" filled rounded
                  :disabled="!user.permissions.Event || !user.permissions.Event.update
              " @blur="_updateEvent()">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="py-0">
                <v-text-field v-model="eventData.socialMedia.instagram" class="mt-0" label="Instagram" filled rounded
                  :disabled="!user.permissions.Event || !user.permissions.Event.update
              " @blur="_updateEvent()">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="py-0">
                <v-text-field v-model="eventData.socialMedia.twitter" class="mt-0" label="Twitter" filled rounded :disabled="!user.permissions.Event || !user.permissions.Event.update
              " @blur="_updateEvent()">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pt-0">
                <v-text-field v-model="eventData.socialMedia.linkedin" class="mt-0" label="LinkedIn" filled rounded
                  :disabled="!user.permissions.Event || !user.permissions.Event.update
              " @blur="_updateEvent()">
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <!--Patrocinadores-->
          <v-col cols="12" class="pb-0">
            <p class="title font-weight-bold text-center">Patrocinadores</p>
          </v-col>
          <v-col v-if="eventData.sponsors && eventData.sponsors.length > 0" cols="12" class="d-flex justify-center py-0">
            <v-row justify="center">
              <v-col v-for="sponsor in eventData.sponsors" :key="sponsor._id" cols="6" sm="4" lg="3" xl="2"
                class="py-2 d-flex justify-center">
                <v-avatar size="120" rounded="0">
                  <v-img class="sponsor-img rounded-xl" lazy-src="https://picsum.photos/id/11/10/6" :src="sponsor.logo"
                    width="auto" contain></v-img>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn absolute fab top right color="red" small class="mt-6"
                        @click="openRemoveSponsorDialog(sponsor)" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              " v-bind="attrs" v-on="on">
                        <v-icon small color="white">mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar patrocinador</span>
                  </v-tooltip>
                </v-avatar>
              </v-col>
              <v-col cols="6" sm="4" lg="3" xl="2" class="py-2 d-flex justify-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="accent" fab x-large @click="sponsorDialog = true" :disabled="!user.permissions.Event ||
              !user.permissions.Event.update
              " v-bind="attrs" v-on="on">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar patrocinador</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-else cols="12" class="d-flex justify-center py-0">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="accent" fab x-large @click="sponsorDialog = true" :disabled="!user.permissions.Event || !user.permissions.Event.update
              " v-bind="attrs" v-on="on">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Agregar patrocinador</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <!--INICIO v-dialog para cargar banner-->
    <!-- <v-dialog v-model="bannerDialog" width="700">
      <v-card>
        <v-card-text :class="$vuetify.breakpoint.smAndUp ? '' : 'px-2'">
          <v-container>
            <v-row>
              <v-col cols="12" class="mt-3 d-flex justify-center">
                <v-img
                  class=""
                  src="@/assets/images/weChamber/logo-WC-main-nav-drawer.svg"
                  max-width="190"
                  height="auto"
                  contain
                ></v-img>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="headline font-weight-bold text-center mb-0">
                  Banner de evento
                </p>
              </v-col>
              <v-col cols="12" class="subtitle-1 text-justify py-0">
                <p>
                  Esta imagen se mostrará en la parte superior del micrositio.
                  Para tener una visualización adecuada se recomienda que la
                  imagen sea de 1500x500 pixeles.
                </p>
              </v-col>
              <v-col cols="12">
                <file-pond
                  name="event-banner"
                  ref="pondBanner"
                  label-idle="Agrega un banner para tu evento..."
                  accepted-file-types="image/jpeg, image/png"
                />
              </v-col>
            </v-row>
            <v-row
              class="d-flex pb-2 mt-5"
              :class="
                $vuetify.breakpoint.smAndUp ? 'justify-end' : 'justify-center'
              "
            >
              <v-btn
                class="mx-2"
                color="grey lighten-2"
                rounded
                @click="bannerDialog = false"
                elevation="0"
                ><span class="font-weight-bold black--text">Cerrar</span></v-btn
              >
              <v-btn
                class="mx-2"
                color="accent"
                rounded
                elevation="0"
                @click="uploadBanner(), (bannerDialog = false)"
                ><span class="font-weight-bold black--text"
                  >Guardar</span
                ></v-btn
              >
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog> -->
    <ImageCroppingDialog :cropperDialog="bannerDialog" @submitImages="uploadBanners" @close="bannerDialog = false">
      <template v-slot:dialogTitle> Banner de evento </template>
      <template v-slot:dialogSubtitle>
        Esta imagen se mostrará en la parte superior del micrositio. Para tener
        una visualización adecuada
        <span class="font-weight-bold">se recomienda que la imagen sea de 1500x500 pixeles</span>.
      </template>
    </ImageCroppingDialog>
    <!--FIN v-dialog para cargar banner-->
    <!--INICIO v-dialog para cargar flyer-->
    <ImageCroppingDialog :flyers="this.eventData.flyer" :cropperDialog="flyerDialog" :flyer="true"
      @submitImage="uploadFlyer($event)" @submitImages="uploadFlyers" @close="flyerDialog = false"
      :show-carousel-switch="true" @banderaImageChange="handleBanderaImageChange"
      @updateMultipleImages="handleMultipleImagesUpdate">
      <template v-slot:dialogTitle> Flyer de evento </template>
      <template v-slot:dialogSubtitle>
        Esta imagen se mostrará en el cuerpo del micrositio. Normalmente se usa
        para mostrar información del evento de una forma más gráfica. Para tener
        una visualización adecuada
        <span class="font-weight-bold">se recomienda que la imagen sea de 800 pixeles de ancho y de alto
          puede ser cualquier medida</span>
        .
      </template>
    </ImageCroppingDialog>
    <!--FIN v-dialog para cargar flyer-->
    <!--INICIO v-dialog para cargar patrocinador-->
    <v-dialog v-model="sponsorDialog" width="700">
      <v-card>
        <v-card-text :class="$vuetify.breakpoint.smAndUp ? '' : 'px-2'">
          <v-container>
            <v-row>
              <v-col cols="12" class="mt-3 d-flex justify-center">
                <v-img class="" src="@/assets/images/weChamber/logo-WC-main-nav-drawer.svg" max-width="190"
                  height="auto" contain></v-img>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="headline font-weight-bold text-center mb-0">
                  Patrocinadores
                </p>
              </v-col>
              <v-col cols="12" class="subtitle-1 text-justify py-0">
                <p>
                  Esta imagen se mostrará en el micrositio. Para tener una
                  visualización adecuada se recomienda que la imagen sea de
                  500x500 pixeles.
                </p>
              </v-col>
              <v-col cols="12">
                <file-pond name="sponsor-image" ref="sponsorImage"
                  label-idle="Agrega una imagen de patrocinador para tu evento..."
                  accepted-file-types="image/jpeg, image/png" />
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-text-field dense filled rounded label="Link al sitio del patrocinador" v-model="sponsorLink">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex pb-2 mt-5" :class="$vuetify.breakpoint.smAndUp ? 'justify-end' : 'justify-center'
              ">
              <v-btn class="mx-2" color="grey lighten-2" rounded @click="
              sponsorDialog = false;
            sponsorLink = '';
            " elevation="0"><span class="font-weight-bold black--text">Cerrar</span></v-btn>
              <v-btn class="mx-2" color="accent" rounded elevation="0" @click="
              uploadSponsor(), (sponsorDialog = false), (sponsorLink = '')
              "><span class="font-weight-bold black--text">Guardar</span></v-btn>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--FIN v-dialog para cargar patrocinador-->
    <!--INICIO v-dialog para eliminar patrocinador-->
    <v-dialog v-model="removeSponsorDialog" width="700">
      <v-card>
        <v-card-text :class="$vuetify.breakpoint.smAndUp ? '' : 'px-2'">
          <v-container>
            <v-row>
              <v-col cols="12" class="mt-3 d-flex justify-center">
                <v-img class="" src="@/assets/images/weChamber/logo-WC-main-nav-drawer.svg" max-width="190"
                  height="auto" contain></v-img>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="headline font-weight-bold text-center mb-0">
                  Patrocinadores
                </p>
              </v-col>
              <v-col cols="12" class="subtitle-1 py-0">
                <p>
                  ¿Está seguro que quiere eliminar la imagen del patrocinador
                  seleccionado?. La imagen no podrá ser recuperada a menos que
                  sea subida nuevamente.
                </p>
              </v-col>
            </v-row>
            <v-row class="d-flex pb-2 mt-5" :class="$vuetify.breakpoint.smAndUp ? 'justify-end' : 'justify-center'
              ">
              <v-btn class="mx-2" color="grey lighten-2" rounded @click="removeSponsorDialog = false"
                elevation="0"><span class="font-weight-bold black--text">Cerrar</span></v-btn>
              <v-btn class="mx-2" color="red" rounded elevation="0" @click="removeSponsor()"><span
                  class="font-weight-bold white--text">Remover</span></v-btn>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--FIN v-dialog eliminar patrocinador-->
    <!--INICIO ESTE DIALOG SE VA A QUITAR-->
    <v-dialog v-model="descriptionDialog" max-width="750">
      <v-card>
        <p class="headline font-weight-medium px-7 pt-5">
          Descripción de evento
        </p>
        <v-card-text class="d-flex justify-center pa-2">
          <tiptap-vuetify v-model="eventData.description" :extensions="extensions"
            :max-height="$vuetify.breakpoint.smAndUp ? '450' : '250'" />
        </v-card-text>
        <v-card-actions class="d-flex justify-end pb-5 pr-5">
          <v-btn color="grey lighten-3" @click="cancelUpdateEvent(), (descriptionDialog = false)">
            Cancelar
          </v-btn>
          <v-btn color="accent" @click="_updateEvent(), (descriptionDialog = false)">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--FIN ESTE DIALOG SE VA A QUITAR-->
    <!--INICIO v-dialog para seleccionar el color primario-->
    <v-dialog v-model="primaryColorDialog" max-width="400">
      <v-card>
        <p class="title font-weight-bold text-center px-7 pt-5">
          Selecciona el color primario
        </p>
        <v-card-text class="d-flex justify-center pa-2">
          <v-color-picker v-model="eventData.micrositeConfiguration.primaryColor" class="v-color-picker-style ma-0 ma-md-2"
            mode="hexa" hide-mode-switch show-swatches swatches-max-height="300px"></v-color-picker>
        </v-card-text>
        <v-card-actions class="d-flex justify-end pb-5 pr-5">
          <v-btn class="font-weight-bold black--text" color="grey lighten-3" rounded elevation="0"
            @click="cancelUpdateEvent(), (primaryColorDialog = false)">Cancelar</v-btn>
          <v-btn class="font-weight-bold black--text" color="accent" rounded elevation="0"
            @click="_updateEvent(), (primaryColorDialog = false)">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--FIN v-dialog para seleccionar el color primario-->
    <!--INICIO v-dialog para seleccionar el color secundario-->
    <v-dialog v-model="secondaryColorDialog" max-width="400">
      <v-card>
        <p class="title font-weight-bold text-center px-7 pt-5">
          Selecciona el color secundario
        </p>
        <div class="d-flex justify-center pa-2">
          <v-color-picker v-model="eventData.micrositeConfiguration.secondaryColor"
            class="v-color-picker-style ma-0 ma-md-2" mode="hexa" hide-mode-switch show-swatches
            swatches-max-height="300px"></v-color-picker>
        </div>
        <v-card-actions class="d-flex justify-end pb-5 pr-5">
          <v-btn class="font-weight-bold black--text" color="grey lighten-3" rounded elevation="0"
            @click="cancelUpdateEvent(), (secondaryColorDialog = false)">Cancelar</v-btn>
          <v-btn class="font-weight-bold black--text" color="accent" rounded elevation="0"
            @click="_updateEvent(), (secondaryColorDialog = false)">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--FIN v-dialog para seleccionar el color secundario-->
    <!--INICIO v-dialog para seleccionar el color del botón-->
    <v-dialog v-model="buttonColorDialog" max-width="400">
      <v-card>
        <p class="title font-weight-bold text-center px-7 pt-5">
          Selecciona el color del botón
        </p>
        <div class="d-flex justify-center pa-2">
          <v-color-picker v-model="eventData.micrositeConfiguration.buttonColor" class="v-color-picker-style ma-0 ma-md-2"
            mode="hexa" hide-mode-switch show-swatches swatches-max-height="300px"></v-color-picker>
        </div>
        <v-card-actions class="d-flex justify-end pb-5 pr-5">
          <v-btn class="font-weight-bold black--text" color="grey lighten-3" rounded elevation="0"
            @click="cancelUpdateEvent(), (buttonColorDialog = false)">Cancelar</v-btn>
          <v-btn class="font-weight-bold black--text" color="accent" rounded elevation="0"
            @click="_updateEvent(), (buttonColorDialog = false)">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--FIN v-dialog para seleccionar el color del botón-->
    <!--INICIO v-dialog para cargar patrocinador-->
    <v-dialog v-model="newEventMicrositeDialog" width="700">
      <v-card>
        <v-card-text :class="$vuetify.breakpoint.smAndUp ? '' : 'px-2'">
          <v-container>
            <v-row>
              <v-col cols="12" class="mt-3 d-flex justify-center">
                <v-img class="" src="@/assets/images/weChamber/logo-WC-main-nav-drawer.svg" max-width="190"
                  height="auto" contain></v-img>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="headline font-weight-bold text-center mb-0">
                  Configuración del micrositio
                </p>
              </v-col>
              <v-col cols="12" class="subtitle-1 text-justify py-0">
                <p>
                  En este apartado podrás configurar todos los datos relevantes
                  sobre tu evento. Por ejemplo, el nombre del evento, colores
                  principales del micrositio, redes sociales, patrocinadores de
                  tu evento.
                </p>
              </v-col>
            </v-row>
            <v-row class="d-flex pb-2 mt-5" :class="$vuetify.breakpoint.smAndUp ? 'justify-end' : 'justify-center'
              ">
              <v-btn class="mx-2" color="grey lighten-2" rounded @click="newEventMicrositeDialog = false"
                elevation="0"><span class="font-weight-bold black--text">Entendido</span></v-btn>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--FIN v-dialog para cargar patrocinador-->
  </v-container>
</template>
<script>
import axios from "axios";

import qs from "query-string";
import { Base64 } from "js-base64";
import Endpoints from "@/share/Endpoints";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
import { imageHelper } from "@/utils/imageProcessing.js";
import { colors } from "@/constants/colors.js";
import { mapState, mapMutations, mapActions } from "vuex";

// Plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// Filepond plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

//VueFilePond
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
const FilePond = vueFilePond(FilePondPluginFileValidateType);

import ImageCroppingDialog from "../../../components/shared/ImageCroppingDialog.vue";
import AudienceDialog from "../../../components/dashboard/audienceRules/AudienceDialog.vue";
import { hasOrganizationChapters } from "@/common/ampiOrganizationUserAccess";

export default {
  components: {
    TiptapVuetify,
    FilePond,
    ImageCroppingDialog,
    AudienceDialog
  },
  data() {
    return {
      imageComponentKey: 0,
      colors,
      company: "",
      emails: [],
      selectedSubgroups: [],
      notifyAllMembersLabel: 'Notificar a todos los miembros activos',
      notifyAllGroupsLabel: 'Notificar a todos los grupos',
      confirmationDialog: false,
      selectedOption: "abortNotify",
      optionsToSelect: [],
      currentAudienceRules: {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [],
        allCategories: {},
      },
      currentAudienceRulesDetails: {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [],
      },
      lastSavedAudienceRules: {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [],
        allCategories: {},
      },
      audienceDraftRules: {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [],
        allCategories: {},
      },
      pendingAudienceRules: null,
      lastSavedExclusiveForMembers: false,
      legacyExclusiveMode: false,
      exclusiveForMembersChanged: false,
      updateEventQueue: Promise.resolve(),
      eventModalities: {
        HYBRID: "Híbrido",
        PRESENTIAL: "Presencial",
        VIRTUAL: "Virtual",
      },
      files: null,
      newEventMicrositeDialog: false,
      bannerDialog: false,
      flyerDialog: false,
      sponsorDialog: false,
      sponsorLink: "",
      removeSponsorDialog: false,
      descriptionDialog: false,
      primaryColorDialog: false,
      secondaryColorDialog: false,
      buttonColorDialog: false,
      place: null,
      description: "",
      removeSponsorSelected: {},
      eventData: {
        _id: "",
        exclusiveForMembers: false,
        published: false,
        banner: "",
        name: "",
        description: "",
        youtubeVideo: "",
        emailContact: "",
        micrositeConfiguration: {
          link: "",
          primaryColor: "",
          secondaryColor: "",
          buttonColor: "",
          textButtonColor: "white",
          hideOnPublicMicrosite: true,
        },
        presentialEventConfiguration: {
          name: "",
          city: "",
          country: "",
          formattedAddress: "",
          latitude: null,
          longitude: null,
        },
        socialMedia: {
          facebook: "",
          instagram: "",
          linkedin: "",
          twitter: "",
          youtubeChanel: "",
        },
      },
      // Copia del objeto del evento. Se usa para guardar los datos del evento de forma temporal, y sirve para regresar los valores de un evento en caso de que el usuario quiera cancelar alguna operación.
      eventTemp: {
        _id: "",
        exclusiveForMembers: false,
        published: false,
        banner: "",
        name: "",
        description: "",
        youtubeVideo: "",
        emailContact: "",
        micrositeConfiguration: {
          link: "",
          primaryColor: "",
          secondaryColor: "",
          buttonColor: "",
          textButtonColor: "white",
        },
        presentialEventConfiguration: {
          name: "",
          city: "",
          country: "",
          formattedAddress: "",
          latitude: null,
          longitude: null,
        },
        virtualEventConfiguration: {
          url: "",
          meetingId: "",
          meetingPassword: "",
        },
      },
      // Diferentes modalidades del evento
      modalityCategories: [
        {
          item: "Presencial",
          value: "PRESENTIAL",
        },
        {
          item: "En línea",
          value: "VIRTUAL",
        },
        {
          item: "Híbrido",
          value: "HYBRID",
        },
      ],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    };
  },
  computed: {
    ...mapState("event", ["eventSelected"]),
    ...mapState("user", ["user"]),
    ...mapState("audienceRules", ["audience_rules"]),
    hasChapters() {
      return hasOrganizationChapters(this.user);
    },
    isFlyerEventTitle() {
      return this.dialogTitle === "Flyer de evento";
    },
    audienceSummary() {
      const labelMap = {
        affiliationTypes: "Tipo de membresía",
        branches: "Sección local",
        subgroups: "Subgrupo",
        memberStatus: "Estatus",
      };
      const rules = this.audienceDraftRules || this.currentAudienceRules || {};
      const details = this.currentAudienceRulesDetails || {};
      const catalog = this.audience_rules || {};
      const grouped = {};
      ['memberStatus', 'affiliationTypes', 'branches', 'subgroups'].forEach((key) => {
        if (rules.allCategories && rules.allCategories[key] === true) {
          grouped[key] = {
            key,
            categoryLabel: labelMap[key] || key,
            names: ['Todos'],
          };
          return;
        }
        const ids = rules[key] || [];
        if (!ids.length) return;
        grouped[key] = {
          key,
          categoryLabel: labelMap[key] || key,
          names: [],
        };
        ids.forEach((id) => {
          const fromDetails = (details[key] || []).find(
            (opt) => String(opt._id) === String(id)
          );
          const fromCatalog = (catalog[key] || []).find(
            (opt) => String(opt._id) === String(id)
          );
          const found = fromDetails || fromCatalog;
          grouped[key].names.push(found ? found.name : id);
        });
      });
      return Object.values(grouped);
    },
    hasAudienceChanges() {
      const normalize = (rules) => {
        const out = {};
        ['memberStatus', 'affiliationTypes', 'branches', 'subgroups'].forEach((key) => {
          out[key] = [...((rules && rules[key]) || [])].map((id) => String(id)).sort();
        });
        out.allCategories = Object.keys((rules && rules.allCategories) || {})
          .sort()
          .reduce((result, key) => {
            result[key] = rules.allCategories[key] === true;
            return result;
          }, {});
        return JSON.stringify(out);
      };
      return normalize(this.pendingAudienceRules || this.audienceDraftRules)
        !== normalize(this.lastSavedAudienceRules)
        || this.eventData.exclusiveForMembers !== this.lastSavedExclusiveForMembers;
    },
  },
  methods: {
    ...mapActions("user", ["realoadUserData"]),
    ...mapActions("event", [
      "fetchEventById",
      "updateEvent",
      "addEventSponsor",
      "removeEventSponsor",
    ]),
    ...mapActions("audienceRules", [
      "fetchOrganizationAudienceRules",
      "getAudienceRuleByCategoryId",
    ]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapMutations("notification", ["show"]),
    emptyAudienceRules() {
      return {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [],
        allCategories: {
          affiliationTypes: false,
          branches: false,
          subgroups: false,
          memberStatus: false,
        },
      };
    },
    buildExclusiveAudienceRules() {
      const rules = this.emptyAudienceRules();
      const available = this.audience_rules || {};
      ['memberStatus', 'affiliationTypes', 'branches', 'subgroups']
        .filter((key) => Object.prototype.hasOwnProperty.call(available, key))
        .filter((key) => !(key === 'branches' && !this.hasChapters))
        .forEach((key) => {
          rules[key] = (available[key] || []).map((option) => option._id);
          rules.allCategories[key] = true;
        });
      return rules;
    },
    syncAudienceDialogState(rules, touched = true) {
      const ref = this.$refs.audience_configs_persistent;
      if (ref && ref.setRules) {
        ref.setRules([], rules, rules.allCategories, touched);
      }
    },
    setExclusiveForMembers(value) {
      const enabled = value === true;
      this.legacyExclusiveMode = false;
      this.exclusiveForMembersChanged = true;
      this.$set(this.eventData, 'exclusiveForMembers', enabled);

      const nextRules = enabled
        ? this.buildExclusiveAudienceRules()
        : this.emptyAudienceRules();
      this.audienceDraftRules = { ...nextRules };
      this.pendingAudienceRules = { ...nextRules };
      this.syncAudienceDialogState(nextRules, true);
    },
    async openNotificationDialog() {
      const modalRef = this.$refs.audience_configs_modal;
      if (modalRef && modalRef.setRules) {
        modalRef.setRules(
          [],
          this.audienceDraftRules,
          this.audienceDraftRules.allCategories,
          false,
        );
      }
      this.confirmationDialog = true;

    },
    async confirmPublish() {
      try {
        this.loading();
        await this.$_publishEvent();

        const modalRef = this.$refs.audience_configs_modal;
        if (modalRef && modalRef.setNotificationsEnabled) {
          await modalRef.saveRules({ event: this.eventData._id });
        }

        this.confirmationDialog = false;
      } catch (error) {
        this.show({
          color: "error",
          text: error.response?.data || "Error al enviar la notificación.",
        });
      } finally {
        this.loaded();
      }
    },
    async loadAudienceRules() {
      if (!this.eventData || !this.eventData._id) {
        const empty = this.emptyAudienceRules();
        const emptyDetails = {
          affiliationTypes: [],
          branches: [],
          subgroups: [],
          memberStatus: [],
        };
        this.currentAudienceRules = { ...empty };
        this.currentAudienceRulesDetails = { ...emptyDetails };
        this.lastSavedAudienceRules = { ...empty };
        this.audienceDraftRules = { ...empty };
        this.pendingAudienceRules = { ...empty };
        return;
      }
      try {
        if (this.fetchOrganizationAudienceRules) {
          try {
            await this.fetchOrganizationAudienceRules();
          } catch (e) {
            // continuar aunque no se pueda poblar el catálogo
          }
        }
        const { data, status } = await this.getAudienceRuleByCategoryId(
          this.eventData._id
        );
        let next;
        let nextDetails;
        if (status && data) {
          next = {
            affiliationTypes: data.affiliationTypes || [],
            branches: data.branches || [],
            subgroups: data.subgroups || [],
            memberStatus: data.memberStatus || [],
            allCategories: data.allCategories || {},
          };
          nextDetails = {
            affiliationTypes: data.affiliationTypesDetails || [],
            branches: data.branchesDetails || [],
            subgroups: data.subgroupsDetails || [],
            memberStatus: data.memberStatus || [],
          };
        } else {
          next = this.emptyAudienceRules();
          nextDetails = {
            affiliationTypes: [],
            branches: [],
            subgroups: [],
            memberStatus: [],
          };
        }
        this.currentAudienceRules = { ...next };
        this.currentAudienceRulesDetails = { ...nextDetails };
        this.lastSavedAudienceRules = { ...next };
        const shouldInferLegacyExclusivity = this.legacyExclusiveMode
          && ['memberStatus', 'affiliationTypes', 'branches', 'subgroups']
            .some((key) => (next[key] || []).length > 0);
        if (this.legacyExclusiveMode) {
          this.$set(this.eventData, 'exclusiveForMembers', shouldInferLegacyExclusivity);
        }
        const hasPersistedRules = ['memberStatus', 'affiliationTypes', 'branches', 'subgroups']
          .some((key) => (next[key] || []).length > 0)
          || Object.values(next.allCategories || {}).some(Boolean);
        const draft = this.eventData.exclusiveForMembers === true && !hasPersistedRules
          ? this.buildExclusiveAudienceRules()
          : { ...next };
        this.audienceDraftRules = draft;
        this.pendingAudienceRules = { ...draft };
        this.lastSavedExclusiveForMembers = this.eventData.exclusiveForMembers === true;
        this.exclusiveForMembersChanged = false;
      } catch (error) {
        const empty = this.emptyAudienceRules();
        const emptyDetails = {
          affiliationTypes: [],
          branches: [],
          subgroups: [],
          memberStatus: [],
        };
        this.currentAudienceRules = { ...empty };
        this.currentAudienceRulesDetails = { ...emptyDetails };
        this.lastSavedAudienceRules = { ...empty };
        this.audienceDraftRules = this.eventData.exclusiveForMembers === true
          ? this.buildExclusiveAudienceRules()
          : { ...empty };
        this.pendingAudienceRules = { ...this.audienceDraftRules };
        this.lastSavedExclusiveForMembers = this.eventData.exclusiveForMembers === true;
        this.exclusiveForMembersChanged = false;
      }
    },
    async openAudienceEditor() {
      if (!this.$refs.audience_configs_persistent) return;
      try {
        this.$refs.audience_configs_persistent.setNotificationsEnabled = false;
      } catch (e) {
        // ignore
      }
      this.$refs.audience_configs_persistent.dialogMenu = true;
    },
    async saveAudienceFromCard() {
      if (!this.eventData || !this.eventData._id) {
        this.show({
          text: "No se pudo identificar el evento para guardar la audiencia.",
          color: "error",
        });
        return;
      }
      if (!this.hasAudienceChanges) {
        return;
      }
      this.loading();
      try {
        await this.saveEventAudienceSettings({
          sourceRef: this.$refs.audience_configs_persistent,
          showSuccess: false,
        });
        this.show({
          text: "Audiencia actualizada correctamente.",
          color: "success",
        });
      } catch (error) {
        this.show({
          text: "No se pudo guardar la audiencia.",
          color: "error",
        });
      } finally {
        this.loaded();
      }
    },
    async saveEventAudienceSettings({ sourceRef = null, showSuccess = true } = {}) {
      if (!this.eventData || !this.eventData._id) return false;
      if (!this.hasAudienceChanges) return true;

      await this._updateEvent();
      const audienceRef = sourceRef
        || this.$refs.audience_configs_persistent;
      if (!audienceRef) return false;

      audienceRef.setNotificationsEnabled = false;
      await audienceRef.saveRules({ event: this.eventData._id });
      await this.loadAudienceRules();
      if (showSuccess) {
        this.show({
          text: "Audiencia actualizada correctamente.",
          color: "success",
        });
      }
      return true;
    },
    onAudienceRulesChange(rules) {
      if (!rules) return;
      const nextRules = {
        affiliationTypes: rules.affiliationTypes || [],
        branches: rules.branches || [],
        subgroups: rules.subgroups || [],
        memberStatus: rules.memberStatus || [],
        allCategories: rules.allCategories || {},
      };
      this.pendingAudienceRules = nextRules;
      this.audienceDraftRules = { ...nextRules };
    },
    changeNotifyGroup() {
      this.selectedSubgroups = [];
    },
    async fetchSubgroups() {
      try {
        const response = await axios.get("/subgroups/");

        const formattedSubgroups = response.data.map((subgroup) => subgroup.name);

        this.optionsToSelect = this.optionsToSelect.concat(formattedSubgroups);
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    },

    handleBanderaImageChange(value) {
      this.banderaImage = value;
    },

    handleMultipleImagesUpdate(isMultiple) {
      this.isMultipleImagesEnabled = isMultiple;
    },

    async fetchEventInformation() {
      let auxEvent = JSON.parse(JSON.stringify(this.eventData));
      await this.fetchEventById(this.$route.params.eventId);

      const hasExclusiveFlag = Object.prototype.hasOwnProperty.call(
        this.eventSelected || {},
        "exclusiveForMembers",
      );
      this.legacyExclusiveMode = !hasExclusiveFlag;
      this.exclusiveForMembersChanged = false;
      this.eventSelected.description = this.eventSelected.description
        ? Base64.decode(this.eventSelected.description)
        : "";
      if (
        this.eventSelected.presentialEventConfiguration &&
        this.eventSelected.presentialEventConfiguration.formattedAddress
      ) {
        this.place =
          this.eventSelected.presentialEventConfiguration.formattedAddress;
      }
      Object.assign(auxEvent, this.eventSelected);
      this.eventData = JSON.parse(JSON.stringify(auxEvent));
      this.$set(
        this.eventData,
        "exclusiveForMembers",
        hasExclusiveFlag ? this.eventSelected.exclusiveForMembers === true : false,
      );
      this.eventTemp = JSON.parse(JSON.stringify(this.eventSelected));
      this.$set(
        this.eventTemp,
        "exclusiveForMembers",
        hasExclusiveFlag ? this.eventSelected.exclusiveForMembers === true : false,
      );
      await this.loadAudienceRules();
    },
    cancelUpdateEvent() {
      this.eventData = JSON.parse(JSON.stringify(this.eventTemp));
    },
    async $_publishEvent() {
      let status = false;
      try {
        const endpoint = qs.stringifyUrl({
          url: Endpoints.publishEvent.replace(
            /:eventId/,
            this.$route.params.eventId
          ),
        });
        const response = await this.axios.put(endpoint);
        if (response.status > 199 && response.status < 300) {
          await this.fetchEventInformation();
          this.eventData.published = true;

          this.show({
            text: "¡Evento publicado correctamente!",
            color: "primary",
          });
        } else {
          this.show({
            text: "¡Ha ocurrido un problema en la publicación del evento!",
            color: "error",
          });
        }
        return !status;
      } catch (error) {
        setTimeout(() => {
          this.show({
            text:
              error.response &&
                error.response.data &&
                error.response.data.error &&
                error.response.data.error.message
                ? error.response.data.error.message
                : "¡Ha ocurrido un problema al querer publicar el evento!",
            color: "error",
          });
        }, 1000);
      }
      return status
    },
    async $_hideEvent() {
      try {
        this.loading();
        const endpoint = qs.stringifyUrl({
          url: Endpoints.hideEvent.replace(
            /:eventId/,
            this.$route.params.eventId
          ),
        });
        const response = await this.axios.put(endpoint);
        if (response.status > 199 && response.status < 300) {
          await this.fetchEventInformation();
          this.show({
            text: "¡Evento ocultado correctamente!",
            color: "primary",
          });
          this.loaded();
        } else {
          this.show({
            text: "¡Ha ocurrido un problema al ocultar el evento!",
            color: "error",
          });
        }
        this.loaded();
      } catch (error) {
        setTimeout(() => {
          this.show({
            text: error.message
              ? error.message
              : "¡Ha ocurrido un problema al querer ocultar el evento!",
            color: "error",
          });
          this.loaded();
        }, 1000);
      }
    },
    async _updateEvent() {
      const eventToSave = JSON.parse(JSON.stringify(this.eventData));
      eventToSave.description = Base64.encode(eventToSave.description);
      if (this.legacyExclusiveMode && !this.exclusiveForMembersChanged) {
        delete eventToSave.exclusiveForMembers;
      }

      // Serialize full-event updates so older blur/change requests cannot
      // overwrite a newer configuration when they finish out of order.
      this.updateEventQueue = this.updateEventQueue
        .catch(() => undefined)
        .then(async () => {
          this.loading();
          try {
            const response = await this.updateEvent(eventToSave);
            if (response.status) {
              const savedEvent = response.data && response.data.event;
              if (savedEvent) {
                this.eventTemp = JSON.parse(JSON.stringify(savedEvent));
                this.$set(
                  this.eventTemp,
                  "exclusiveForMembers",
                  this.eventData.exclusiveForMembers === true,
                );
                this.eventTemp.description = Base64.decode(
                  this.eventTemp.description
                );
              }
            } else {
              console.log(response.message);
            }
          } catch (error) {
            console.log(error.message);
          } finally {
            this.loaded();
          }
        });

      return this.updateEventQueue;
    },
    async uploadBanners(bannersArray) {
      this.loading();
      for (const banner of bannersArray) {
        await this.uploadBanner(banner);
      }
      this.loaded();
    },
    async uploadBanner(file) {
      this.loading();
      let bannerTemp = await imageHelper.resizeImg(file, 1500, 500);
      this.eventData.banner = await imageHelper.saveImage(bannerTemp);
      console.log(this.eventData.banner);
      await this._updateEvent();
      this.bannerDialog = false;
      // Cuando este en producción quitar el setTimeout
      this.loaded();
    },
    async uploadFlyers(flyersArray) {
      this.loading();
      for (const flyer of flyersArray) {
        await this.uploadFlyer(flyer);
      }
      this.imageComponentKey += 1
      this.loaded();
    },
    async uploadFlyer(file, indexToUpdate) {
      if (!this.isMultipleImagesEnabled) {
        this.eventData.flyer = "";
      }
      this.banderaImage == true;
      let flyerTemp = await imageHelper.resizeImg(file, 800, 2000);
      const flyerLink = await imageHelper.saveImage(flyerTemp);

      console.log("Enlace del flyer:", this.eventData.flyer);

      // Divide los enlaces existentes por comas
      let existingFlyers = this.eventData.flyer ? this.eventData.flyer.split(",") : [];

      if (indexToUpdate !== undefined && existingFlyers[indexToUpdate]) {
        // Actualiza la imagen en el índice específico
        existingFlyers[indexToUpdate] = flyerLink;
      } else if (existingFlyers.length < 3) {
        // Agrega una nueva imagen si el arreglo tiene menos de 3 elementos
        existingFlyers.push(flyerLink);
      } else {
        // Reemplaza la primera imagen si el arreglo ya tiene 3 elementos
        existingFlyers[0] = flyerLink;
      }

      console.log("Enlaces existentes:", existingFlyers);

      // Une los enlaces y actualiza el estado
      this.eventData.flyer = existingFlyers.join(",");

      console.log("Enlace del flyer:", this.eventData.flyer);

      await this._updateEvent();
      this.flyerDialog = false;
    },

    async uploadSponsor() {
      this.loading();
      const link = this.sponsorLink;
      const file = this.$refs.sponsorImage.getFiles()[0].file;
      let sponsorTemp = await imageHelper.resizeImg(file, 400, 400);
      let sponsorImg = await imageHelper.saveSponsorImage(sponsorTemp);

      let sponsorData = {
        eventId: this.$route.params.eventId,
        name: "",
        logo: sponsorImg,
        url: link,
      };
      await this.addEventSponsor(sponsorData);
      this.sponsorDialog = false;
      this.$refs.sponsorImage.removeFiles();
      // Cuando este en producción quitar el setTimeout
      setTimeout(() => {
        this.loaded();
      }, 500);
      await this.fetchEventInformation();
    },
    async removeSponsor() {
      this.loading();
      let sponsorData = {
        eventId: this.$route.params.eventId,
        sponsorId: this.removeSponsorSelected._id,
        logo: this.removeSponsorSelected.logo,
      };
      await this.removeEventSponsor(sponsorData);
      await this.fetchEventInformation();
      this.removeSponsorDialog = false;
      setTimeout(() => {
        this.loaded();
      }, 500);
    },
    /**
     * Función para borrar un patrocinador de la lista de patrocinadores
     */
    openRemoveSponsorDialog(sponsor) {
      this.removeSponsorSelected = sponsor;
      this.removeSponsorDialog = true;
    },
    /**
     * Función para guardar dirección del evento una vez que ha sido ingresada en el campo de dirección de evento.
     */
    async saveAddress(place) {
      let {
        geometry: {
          location: { lat },
        },
        geometry: {
          location: { lng },
        },
        formatted_address,
        name,
      } = place;
      let flag = isNaN(place.address_components.slice(-1)[0].short_name)
        ? true
        : false;
      let components = [];
      if (flag) components = [...place.address_components].slice(-3);
      else components = [...place.address_components].slice(-4);

      this.eventData.presentialEventConfiguration = {
        name,
        city: components[0].long_name,
        country: components[2].long_name,
        formattedAddress: formatted_address,
        latitude: lat(),
        longitude: lng(),
        //state: components[1].short_name,
      };
      this.place = formatted_address;
      await this._updateEvent();
    },
    dateEvent() {
      if (
        this.eventData.dateConfiguration &&
        this.eventData.dateConfiguration.startDate != ""
      ) {
        let startDate =
          this.dateFormatted(
            this.eventData.dateConfiguration.startDate.substring(0, 16)
          ) +
          "-" +
          this.eventData.dateConfiguration.startDate.substring(0, 4);
        let endDate =
          this.dateFormatted(
            this.eventData.dateConfiguration.endDate.substring(0, 16)
          ) +
          "-" +
          this.eventData.dateConfiguration.endDate.substring(0, 4);
        if (startDate == endDate) {
          return startDate;
        } else {
          return `${startDate} / ${endDate}`;
        }
      } else {
        return "";
      }
    },
    dateFormatted(eventDate) {
      const date = new Date(eventDate);
      const month = date.toLocaleString("es-mx", { month: "long" });
      const day = date.getDate();
      return `${("00" + day).slice(-2)}-${month}`;
    },
  },
  async mounted() {
    if (this.user.role !== 'BRANCH') {
      await this.fetchSubgroups();
    }
    try {
      await this.fetchOrganizationAudienceRules();
    } catch (e) {
      // continuar aunque no se pueda poblar el catálogo de audiencia
    }
    await this.fetchEventInformation();
    this.eventTemp = JSON.parse(JSON.stringify(this.eventData));
  },
};
</script>
<style scoped>
.bg-color {
  background-color: aquamarine;
}

.sponsor-img {
  filter: grayscale(1);
  height: auto;
  /*max-height: 100px;
  width: 100%;
  max-width: 150px;*/
  transition: 0.2s all ease-in-out;
  border-radius: 15px;
  justify-self: center;
}

.v-color-picker-style {
  background-color: #ffffff00;
}
</style>
